import React, { useState } from 'react';
import Card from '../shared/Card';
import StageIndicator from './StageIndicator';
import StageOne from './StageOne';
import StageTwo from './StageTwo';
import './IntakeForm.css';

const IntakeForm = ({ onSubmitComplete }) => {
  const [currentStage, setCurrentStage] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    kernel_text: '',
    attachment_text: null,
    provider_details: {
      name: '',
      background: '',
      experience: ''
    }
  });

  const handleNext = () => {
    setCurrentStage(currentStage + 1);
  };

  const handleBack = () => {
    setCurrentStage(currentStage - 1);
  };

  const handleSubmit = async (submitData) => {
    setIsSubmitting(true);
    try {
      await onSubmitComplete(submitData);
    } catch (error) {
      console.error('Submission error:', error);
      setIsSubmitting(false);
    }
  };

  const renderStage = () => {
    switch (currentStage) {
      case 1:
        return (
          <StageOne
            formData={formData}
            setFormData={setFormData}
            onNext={handleNext}
          />
        );
      case 2:
        return (
          <StageTwo
            formData={formData}
            setFormData={setFormData}
            onBack={handleBack}
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
          />
        );
      default:
        return null;
    }
  };

  const getStageTitle = () => {
    switch (currentStage) {
      case 1:
        return 'Submit Belief';
      case 2:
        return 'Provider Details';
      default:
        return '';
    }
  };

  return (
    <div className="intake-form">
      <StageIndicator currentStage={currentStage} totalStages={2} />
      <Card title={getStageTitle()}>
        {renderStage()}
      </Card>
    </div>
  );
};

export default IntakeForm;
